import { CButton, CCol, CLabel, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall, apiCallSPGet, apiCallSPPost } from "src/_apiConfig/apiCall";
import { addToastError, addToastSuccess } from "src/_constants/alert.type";
import Auth from "src/auth";
import { formatDateTime } from "src/shared/Format/dateFormat";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import Badge from "src/views/common/controller/Badge";
import { useHistory } from "react-router-dom";
import ModalPaymentTransactionHistory from "./ModalPaymentTransactionHistory";
//import CommonList from "src/views/common/CommonList";

const LotListViewLotLeftRequest = (props) => {
  let history = useHistory();
  const { authenticated } = Auth();
  const [viewLotLeftRequestDetails, setViewLotLeftRequestDetails] = useState(
    []
  ); // List data manage

  const [viewLLR, setViewLLR] = useState({});
  const [viewLLRPayment, setViewLLRPayment] = useState({});
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  const [CPopUpAmount, setCPopUpAmount] = useState();

  // adding button loader
  const [ButtonLoader, SetButtonLodaer] = useState(false);

  const [showpaymentHistory, setshowpaymentHistory] = useState(false);
  const [paymentTransactionHistory, setpaymentTransactionHistory] = useState(
    []
  );
  const [popupGRFEId, setpopupGRFEId] = useState(0);

  const handleConfirmationPopUpModalClose = () => {
    setCPopUpDisplayConfirmationModal(false);
  };

  //-------------------------------------------------------
  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext,
    amount
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
    setCPopUpAmount(amount);
  };

  const LotLeftRequestByBidder = async () => {
    SetButtonLodaer(true);
    const data = JSON.stringify({
      lotId: parseInt(props.viewListDetails.lotId),
      insertedBy: parseInt(authenticated.userId),
    });
    await apiCallSPPost("LotLeftRequest/Insert", data, 0)
      .then(async (res) => {
        if (res.success) {
          console.log("handleSubmit : ", res);
          addToastSuccess(props.setToasts, res.message);
          handleConfirmationPopUpModalClose();
          window.location.reload();
        } else {
          console.log("handleSubmit error: ", res);
          addToastError(props.setToasts, res.message, 0);
        }
      })
      .finally(() => {
        SetButtonLodaer(false);
      });
  };
  const LotLeftRequestPayment = async (id, llrid, amount) => {
    history.push(
      `/submitlotleftrequestpayment/${window.btoa(id)}/${window.btoa(
        llrid
      )}/ ${window.btoa(amount)}`,
      {
        from: window.location.href,
      }
    );
  };
  const SubmitConfirmationPopUpResponse = async () => {
    console.log("CPopUpIndex", CPopUpIndex);
    if (CPopUpId === 1) {
      return LotLeftRequestByBidder();
    } else if (CPopUpId === 2) {
      console.log("LotLeftRequestPayment", CPopUpAmount);
      return LotLeftRequestPayment(
        parseInt(props.viewListDetails.lotId),
        viewLLR?.lotLeftRequestId,
        CPopUpAmount
      );
    }
  };
  useEffect(() => {
    if (props.viewListDetails.isLotLeftRequest === true) {
      getLotLeftRequest(parseInt(props.viewListDetails.lotId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.viewListDetails.isLotLeftRequest]);

  const getLotLeftRequest = async (id) => {
    //if (authenticated) {

    await apiCallSPGet(`LotLeftRequest/SelectByLotId?LotId=${id}`).then(
      (res) => {
        if (res.success) {
          console.log("getRoleDetails", res.data);
          setViewLotLeftRequestDetails([res.data]);
          setViewLLR(res.data);
          setViewLLRPayment(res.data?.paymentDescription);
          // setApprovalStatus(res.data?.approvalStatus);
          // setPaymentStatus(res.data?.paymentStatus);
          // setLotLeftRequestId(res.data?.lotLeftRequestId);
          //setPayAmount(res.data?.payAmount);
        }
      }
    );
    console.log("setViewLotLeftRequestDetails", viewLotLeftRequestDetails);
    // }
  };
  const DisplayLable = (
    key,
    label,
    value,
    isdate = false,
    isStatus = false,
    className = ""
  ) => {
    return (
      <>
        {className !== "" ? (
          <CCol className={className}>
            {label !== "" && (
              <>
                <CLabel htmlFor="exampleFormControlInput1" key={`label${key}`}>
                  {label} :
                </CLabel>
                <br />
              </>
            )}
            <CLabel htmlFor="exampleFormControlInput1" key={`labelValue${key}`}>
              {isdate && (
                <b>
                  {value === null || value === "0001-01-01T00:00:00"
                    ? "-"
                    : formatDateTime(value)}
                </b>
              )}
              {!isdate && !isStatus && <b>{value === null ? "-" : value}</b>}
            </CLabel>
          </CCol>
        ) : (
          <CCol col={12} xs={12} sm={6} md={4} lg={4} xl={2}>
            {label !== "" && (
              <>
                <CLabel htmlFor="exampleFormControlInput1" key={`label${key}`}>
                  {label} :
                </CLabel>
                <br />
              </>
            )}
            <CLabel htmlFor="exampleFormControlInput1" key={`labelValue${key}`}>
              {isdate && (
                <b>
                  {value === null || value === "0001-01-01T00:00:00"
                    ? "-"
                    : formatDateTime(value)}
                </b>
              )}
              {!isdate && !isStatus && <b>{value === null ? "-" : value}</b>}
            </CLabel>
          </CCol>
        )}
      </>
    );
  };

  const DisplayStatusBadge = (value, key, className = "") => {
    return (
      value !== null &&
      (value === "Pending" ? (
        <Badge
          key={`pending-span${key}`}
          color={"warning"}
          label={"Pending"}
          isOld="true"
          className={className}
        />
      ) : value === "Approved" ? (
        <Badge
          key={`approved-span${key}`}
          color={"success"}
          label={"Approved"}
          isOld="true"
          className={className}
        />
      ) : (
        <Badge
          key={`rejected-span${key}`}
          color={"danger"}
          label={"Rejected"}
          isOld="true"
          className={className}
        />
      ))
    );
  };
  const DisplayStatus = (prefixkey, key, label, value) => {
    return (
      <CCol className="mb-2" col={12} xs={12} sm={6} md={4} lg={4} xl={2}>
        <CLabel key={`${prefixkey}${key}`} htmlFor="exampleFormControlInput1">
          {label}
        </CLabel>
        <h5>{DisplayStatusBadge(value, key)}</h5>
      </CCol>
    );
  };

  const ViewBankTransaction = async (lotId, paymentType, Id) => {
    // props.setIdForPaymentHistory(lotId);
    // props.setTypeForPaymentHistory(paymentType);
    setpopupGRFEId(Id);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "PaymentHistory/GetPaymentHistory",
      "POST",
      header,
      JSON.stringify({
        LotId: lotId,
        PaymentType: paymentType,
        otherId: Id,
      })
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setpaymentTransactionHistory(jsonobj);
    } else {
      setpaymentTransactionHistory([]);
    }

    setshowpaymentHistory(true);
  };

  const LotLeftHeder = () => {
    return (
      <CRow className="pt-3 mt-3">
        <CCol className="mb-2" xl={12}>
          <h3 className="titlehr">Lot Left </h3>
          <strong>Notes : </strong>
          If you request a "Lot Left", HO confirmation is required. After HO
          approval, you must pay a "Lot Left" fee, which is 5% of the purchase
          price. Once the payment is successful, the "Lot Left" will be
          processed automatically.
        </CCol>
      </CRow>
    );
  };
  const dateArray = viewLLRPayment?.date
    ? viewLLRPayment.date.split(":")
    : null;

  // const SetDateFromate = (value) => {
  //   return (
  //     <td className="py-2">
  //       <span>{value === null ? "" : formatDateTime(value)}</span>
  //     </td>
  //   );
  // };

  // let scopedSlotsGodownRentList = {
  //   insertDateTimeFormat: (item, index) => {
  //     return SetDateFromate(item.insertDateTime);
  //   },
  //   approvalDateFormat: (item, index) => {
  //     return SetDateFromate(item.approvalDate);
  //   },
  //   ApprovalStatus: (item, index) => {
  //     return (
  //       <td className="py-2">
  //         {DisplayStatusBadge(item.approvalStatus, index, "badgeFont100")}
  //       </td>
  //     );
  //   },
  //   PaymentStatus: (item, index) => {
  //     return (
  //       <td className="py-2">
  //         {DisplayStatusBadge(item.paymentStatus, index, "badgeFont100")}
  //       </td>
  //     );
  //   },
  // };

  // const fields = [
  //   {
  //     key: "insertedBy",
  //     label: "Request By",
  //     _style: { width: "15%" },
  //   },
  //   {
  //     key: "insertDateTimeFormat",
  //     label: "Request Date",
  //     _style: { width: "12.5%" },
  //   },
  //   {
  //     key: "approvedBy",
  //     label: "Approval By",
  //     _style: { width: "15%" },
  //   },
  //   {
  //     key: "approvalDateFormat",
  //     label: "Approval Date",
  //     _style: { width: "12.5%" },
  //   },
  //   {
  //     key: "ApprovalStatus",
  //     label: "HO Approval",
  //     _style: { width: "10%" },
  //   },
  //   {
  //     key: "PaymentStatus",
  //     label: "Payment",
  //     _style: { width: "10%" },
  //   },
  //   {
  //     key: "amount",
  //     label: "Amount (5%)",
  //     _style: { width: "7.5%" },
  //   },

  //   {
  //     key: "cgst",
  //     label: "CGST",
  //     _style: { width: "5%" },
  //     sorter: false,
  //     filter: false,
  //   },
  //   {
  //     key: "sgst",
  //     label: "SGST",
  //     _style: { width: "5%" },
  //     sorter: false,
  //     filter: false,
  //   },
  //   {
  //     key: "igst",
  //     label: "IGST",
  //     _style: { width: "5%" },
  //     sorter: false,
  //     filter: false,
  //   },
  // ];
  return (
    <>
      {props.viewListDetails.tenderType === 1 &&
        props.viewListDetails.isLotLeftRequest === false &&
        authenticated.role === "Bidder" &&
        props.EmdPaid.isEMDPaid === false &&
        (props.EmdPaid.lotPaymentViewModel.type === 3 ||
          props.EmdPaid.lotPaymentViewModel.type === 0) &&
        (props.viewListDetails.emdStatusCode === "Pending" ||
          props.viewListDetails.emdStatusCode === "") &&
        props.viewListDetails.lotTransferCount === 0 && (
          <>
            {/* <br /> */}
            <div key="divsLotLeftRequest">
              {LotLeftHeder()}
              <CRow className="mt-1">
                <CCol xl={12}>
                  <CButton
                    key={"btnLotLeftRequest"}
                    color="info"
                    className="mt-1"
                    onClick={() =>
                      ConfirmationPopupHandler(
                        1,
                        1,
                        "Are you sure you want to proceed for 'Lot Left Request'?",
                        0
                      )
                    }
                  >
                    Lot Left Request
                  </CButton>
                </CCol>
              </CRow>
            </div>
          </>
        )}
      {viewLotLeftRequestDetails.length > 0 && (
        <>
          <br />
          {LotLeftHeder()}
          {/* {viewLLR !== null && (
            <div className="viewTable">
              <CommonList
                key={"List_viewLLR"}
                listName=""
                items={[viewLLR]}
                fields={fields}
                loading={false}
                disabledprev={true}
                disablednext={true}
                displayPaggingButton={false}
                scopedSlots={scopedSlotsGodownRentList}
              />
            </div>
          )} */}
          {viewLLR !== null && (
            <div className="pl-1 pr-1">
              <>
                <CRow className="mt-3">
                  {DisplayLable("key11", "Request By", viewLLR.insertedBy)}
                  {DisplayLable(
                    "key12",
                    "Request Date",
                    viewLLR.insertDateTime,
                    true
                  )}
                  {DisplayLable("key12", "Approval By", viewLLR.approvedBy)}
                  {DisplayLable(
                    "key13",
                    "Approval Date",
                    viewLLR.approvalDate,
                    true
                  )}
                  {DisplayStatus(
                    "label span",
                    "key14",
                    "HO Approval Status :",
                    viewLLR.approvalStatus
                  )}
                  {DisplayStatus(
                    "label approveduser span",
                    "key15",
                    "Payment Status :",
                    viewLLR.paymentStatus
                  )}
                  {DisplayLable("key16", "Amount (5%)", viewLLR.amount)}
                  {DisplayLable("key17", "CGST", viewLLR.cgst)}
                  {DisplayLable("key18", "SGST", viewLLR.sgst)}
                  {DisplayLable("key19", "IGST", viewLLR.igst)}
                </CRow>
              </>
            </div>
          )}
          {/* {viewLotLeftRequestDetails.map((data, key) => (
            <div className="pl-1 pr-1">
              <>
                <CRow className="mt-3">
                  {DisplayLable(key, "Request By", data.insertedBy)}
                  {DisplayLable(key, "Request Date", data.insertDateTime, true)}
                  {DisplayLable(key, "Approval By", data.approvedBy)}
                  {DisplayLable(key, "Approval Date", data.approvalDate, true)}
                  {DisplayStatus(
                    "label span",
                    key,
                    "HO Approval Status :",
                    data.approvalStatus
                  )}
                  {DisplayStatus(
                    "label approveduser span",
                    key,
                    "Payment Status :",
                    data.paymentStatus
                  )}
                  {DisplayLable(key, "Amount (5%)", data.amount)}
                  {DisplayLable(key, "CGST", data.cgst)}
                  {DisplayLable(key, "SGST", data.sgst)}
                  {DisplayLable(key, "IGST", data.igst)}
                </CRow>
              </>
            </div>
          ))} */}
          {viewLLRPayment != null && viewLLRPayment?.paymentMode && (
            <CRow className="mt-1">
              {DisplayLable(
                "key1",
                "Payment Mode",
                viewLLRPayment?.paymentMode
              )}
              {DisplayLable(
                "key2",
                "Current Status",
                viewLLRPayment?.currentStatus
              )}
              {DisplayLable("key3", "Paid Amount", viewLLRPayment?.amount)}
              {DisplayLable(
                "key4",
                dateArray ? dateArray[0].trim() : "Date",
                dateArray && dateArray.length > 1
                  ? dateArray.slice(1).join(":").trim()
                  : ""
              )}
              {DisplayLable(
                "key5",
                "",
                props.viewListDetails.isLotLeftRequest === true &&
                  viewLLR.isPaymentHistory === true && (
                    <>
                      <CButton
                        color="info"
                        className="ml-2 mt-1"
                        style={{ height: "35px" }}
                        onClick={() =>
                          ViewBankTransaction(
                            props.viewListDetails.lotId,
                            "LFT",
                            viewLLR.id
                          )
                        }
                      >
                        History
                      </CButton>

                      <CButton
                        color="info"
                        className="ml-2 mt-1"
                        style={{ height: "35px" }}
                        onClick={() =>
                          props.PaymentStatusViewHanlder(viewLLR.paymentTranId)
                        }
                      >
                        Receipt
                      </CButton>
                    </>
                  ),
                false,
                false,
                "col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
              )}
            </CRow>
          )}
        </>
      )}


{/* {props.EmdPaid.isEMDPaid === false ? "EMD Paid" : "EMD Not Paid"} <br />
        {props.viewListDetails.lotTransferCount}<br />
        {props.viewListDetails.isLotLeftRequest === true ? "Lot Left req done" : " lot left req not done"} <br />
        {props.viewListDetails.isLotLeft === true ? "Lot Left" : "Lot left not done"} <br />

{"Approval Status: " + viewLLR?.approvalStatus}<br />
{"Payment Status:" + viewLLR?.paymentStatus} */}

      {props.EmdPaid.isEMDPaid === false &&
        props.viewListDetails.lotTransferCount === 0 &&
        props.viewListDetails.isLotLeftRequest === true &&
        props.viewListDetails.isLotLeft === false &&
        authenticated.role === "Bidder" &&
        viewLLR?.approvalStatus === "Approved" &&
        viewLLR?.paymentStatus === "Pending" && (
          <CRow className="mt-1">
            <CCol xl={12}>
              <CButton
                className="mt-1"
                color="success"
                onClick={() =>
                  ConfirmationPopupHandler(
                    2,
                    1,
                    "Are you sure you want to pay Lot Left Payment via Online ?",
                    viewLLR.payAmount
                  )
                }
              >
                Pay ={viewLLR.payAmount}
              </CButton>
            </CCol>
          </CRow>
        )}
      {props.viewListDetails.isLotLeftRequest === true &&
        viewLLR.isPaymentHistory === true &&
        viewLLR.isPaymentPaid !== true && (
          <>
            <CButton
              color="info"
              className="ml-2 mt-1"
              style={{ height: "35px" }}
              onClick={() =>
                ViewBankTransaction(
                  props.viewListDetails.lotId,
                  "LFT",
                  viewLLR.id
                )
              }
            >
              History
            </CButton>
          </>
        )}
      <ConfirmationPopup
        key={"CPopupLotLeftRequest"}
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={1}
        ModalBody={CPopUpBodyText}
        // ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        ButtonLoader={ButtonLoader}
      />
      <ModalPaymentTransactionHistory
        key={"paymentTransactionHistoryLLR"}
        setshowpaymentHistory={setshowpaymentHistory}
        showpaymentHistory={showpaymentHistory}
        paymentTransactionHistory={paymentTransactionHistory}
        LotId={props.viewListDetails.lotId}
        paymentType={"LFT"}
        grfeId={popupGRFEId}
        setpaymentTransactionHistory={setpaymentTransactionHistory}
      />
    </>
  );
};

export default LotListViewLotLeftRequest;
